import * as types from 'modules/statistics/actionTypes';
import { generateInitialState } from 'modules/statistics/reducer/data/selfServiceDetails/status/utils';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {{[requestType in keyof SelfServiceRequestType]: Array<boolean>}} State */

/**
 * @param {State} state
 * @param {import('modules/statistics/types').FetchDetailsSelfServiceStatisticsRequestAction} action
 * @returns {State}
 */
const isFetching = (state, { payload: { includedRequestTypes } }) =>
  includedRequestTypes.reduce((acc, type) => ({ ...acc, [type]: true }), state);

/**
 * @param {State} state
 * @param {import('modules/statistics/types').FetchSelfServiceStatisticsSuccessAction | import('modules/statistics/types').FetchSelfServiceStatisticsFailureAction} action
 * @returns {State}
 */
const isEnding = (state, { meta: { includedRequestTypes } }) =>
  includedRequestTypes.reduce((acc, type) => ({ ...acc, [type]: false }), state);

export default createReducer(generateInitialState(false), {
  [types.FETCH_DETAILS_SELF_SERVICE_STATS]: isFetching,
  [types.FETCH_DETAILS_SELF_SERVICE_STATS_SUCCESS]: isEnding,
  [types.FETCH_DETAILS_SELF_SERVICE_STATS_FAILURE]: isEnding,
});
